module.exports = __webpack_public_path__ + "assets/img/favicons/apple-icon-72x72.png";